import { render, staticRenderFns } from "./select-location-dialog.vue?vue&type=template&id=1b477934&"
import script from "./select-location-dialog.vue?vue&type=script&lang=js&"
export * from "./select-location-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports